import React, { useState, useEffect } from "react";
import '../styles/tiles.css';
import '../styles/other.css';
import Axios from 'axios';

// import utilities
import { checkForErrorsInRequest } from '../utilities/RequestsUtilities.js';

// import components
import EditButtonDropdown from '../components/EditButtonDropdown.js';

class FinWorkflowTile extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            noRecordsFound: false,
            listOfUsers: ([{id:1, label: "John Smith"},{id:1, label: "Peter Novak"},{id:1, label: "Somebody Else"}]),
            listOfCountry: ([{id:1, label: "Czech republic"},{id:1, label: "United States"},{id:1, label: "Ukraine"}]),
            listOfRoles: ([{id:1, label: "CTL approvement"},{id:1, label: "Reasonability Pre-check"},{id:1, label: "GT approvement"}]),
            selectedCountry: 0,
            selectedRole: 0,
            selectedUser: 0,
        }
    }

    componentDidMount(){
    }

    onDelete = (id) => {
        alert("onDelete action!");
    }

    onRoleClick = (id) => {
        //code
    }

    render() {
        return (
            <div className="universalLeftTileWithTable" style={{marginBottom: 20}}>
                <span className="fontPoppinsSemiBold15 clickable">Financial Workflow</span>

                <div className="horizontalStack" style={{position: "relative", backgroundColor: "var(--lightest-gray)", marginTop: 20, marginBottom: 20}}>

                    <div className="verticalStack flex" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20, paddingBottom: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Select User:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="user" id="user" style={{}} value={this.state.selectedUser} onChange={e => this.setState({ selectedUser: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfUsers.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack flex" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Select Role:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="role" id="role" style={{}} value={this.state.selectedRole} onChange={e => this.setState({ selectedRole: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfRoles.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                    <div className="verticalStack flex" style={{paddingLeft: 20, paddingTop: 20, paddingRight: 20}}>
                        <span className="fontPoppinsRegular13" style={{marginBottom: 5}}>Select Country:*</span>
                        <select className="universalTextInput topMenuSelectBox" name="country" id="country" style={{}} value={this.state.selectedCountry} onChange={e => this.setState({ selectedCountry: e.target.value })}>
                            <option value=""></option>
                            {this.state.listOfCountry.map(function (item) {
                                return (
                                   <option value={item.id}>{item.label}</option>
                                )
                            }.bind(this))}
                        </select>
                    </div>

                </div>


                <div className="horizontalStackCenter">

                        <table className="universalTableInLeftTile" style={{marginTop: 10}}>
                            <tr>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">User</td>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Role</td>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Country</td>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Role Created By</td>
                                <td className="universalTableInLeftTileHeader" nowrap="nowrap">Edit</td>
                            </tr>

                            {this.props.workflowData.map(function (item) {
                                return (
                                    <tr key={item.id} onClick={() => this.onRoleClick(item.id)}>
                                        <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap">{item.user}</td>
                                        <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap">{item.role}</td>
                                        <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap">{item.country}</td>
                                        <td className="universalTableInLeftTileGeneralDiv responsiveTableDiv" nowrap="nowrap">{item.created_by}</td>
                                        <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap">
                                            <EditButtonDropdown itemId={item.id} onEdit={this.props.setEditRole} onDelete={this.onDelete} text={"Are you sure want to delete this role?"}/>
                                        </td>
                                    </tr>
                                )
                            }.bind(this))}

                            {/* if array empty but not because I received nothing from API then show row with text "Loading..." */}
                            {this.props.workflowData.length == 0 && !this.state.noRecordsFound ? <tr> <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap" colspan="5" style={{textAlign: "center", padding: 10}}>{"Loading..."}</td> </tr> : null}

                            {/* if array empty because I did not receive any records, then show row with text like "No Records Found" */}
                            {this.props.workflowData.length == 0 && this.state.noRecordsFound ? <tr> <td className="universalTableInLeftTileGeneralDiv" nowrap="nowrap" colspan="5" style={{textAlign: "center", padding: 10}}>{"No Roles Yet"}</td> </tr> : null}

                        </table>

                </div>

            </div>
        );
    }
}

export default FinWorkflowTile;
